const CustomMapMarker2 = () => {
  const markerContentArray = [
    '<div class="w-[62px] h-[62px] relative">',
    '<img src="https://waasrzvnijhadqtenzsq.supabase.co/storage/v1/object/public/product/marker.png" alt="Custom Marker" />',
    "</div>",
  ];
  return markerContentArray.join("");
};

export default CustomMapMarker2;
